import type { ITableHeaderCell } from "libs/design-system/src/types/table/table_header/table_header_cell";
import styles from "./table-header-cell.module.scss";

export const TableHeaderCell = ({
  width,
  text,
  disabled = false
}: ITableHeaderCell) => {
  return (
    <div
      role="columnheader"
      style={{ ...(width ? { width: width } : {}) }}
      className={`${styles["table-header-cell"]} ${disabled ? styles['table-header-cell--disabled'] : ''}`}
    >
      <div className={styles["table-header-cell__content"]}>
        {text}
      </div>
    </div>
  )
}